import { createContext, useContext } from "react";

type TaskActionContextType = {
  onClose: () => void;
};

export const TaskActionContext = createContext<TaskActionContextType | undefined>(undefined);

export const useTaskActionContext = () => {
  const ctx = useContext(TaskActionContext);
  if (!ctx) {
    throw new Error("useTaskActionContext must be used within a <TaskActionButton>");
  }
  return ctx;
};
